import drawingSlice from '@/components/DrawingNav/drawingSlice'
import layerListSlice from '@/components/LayerList/layerListSlice'
import menuSlice from '@/components/Menu/menuSlice'
import notificationsSlice from '@/components/Notifications/notificationsSlice'
import pqMapSlice, { loadPQMap } from '@/components/PQMap/pqMapSlice'
import saveSlice from '@/components/SavePage/saveSlice'
import searchSlice, { getPointLayerSearchResultByFipsApn, getSearchResults, selectSearchResult, setSelectedSearchResult } from '@/components/Search/searchSlice'
import { combineReducers, configureStore, createAction, type UnknownAction } from '@reduxjs/toolkit'

export const resetAppState = createAction('app/reset');
const appReducer = combineReducers({
    pqMap: pqMapSlice,
    notifications: notificationsSlice,
    menu: menuSlice,
    search: searchSlice,
    layerList: layerListSlice,
    drawing: drawingSlice,
    save: saveSlice,
});

// ArcGIS objects (WebMap, layers, geometries) are kept in Redux by design and are never serialized.
const arcgisPayloadActions = [
    loadPQMap.fulfilled,
    getSearchResults.fulfilled,
    getPointLayerSearchResultByFipsApn.fulfilled,
    selectSearchResult.fulfilled,
    setSelectedSearchResult,
].map((action) => action.type);
const arcgisStatePaths = [
    'pqMap.webMap', 'pqMap.mapLayers', 'pqMap.polygonLayer', 'pqMap.pointLayer', 'pqMap.thumbnailTable', 'pqMap.notificationTable',
    'search.searchResults', 'search.selectedSearchResult',
];

export const store = configureStore({
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: arcgisPayloadActions,
            // Thunk arguments carry layers and search results.
            ignoredActionPaths: ['meta.arg', 'meta.baseQueryMeta'],
            ignoredPaths: arcgisStatePaths,
        }
    }),
    devTools: import.meta.env.DEV,
    reducer: (state: ReturnType<typeof appReducer> | undefined, action: UnknownAction) => appReducer(resetAppState.match(action) ? undefined : state, action),
})

// Infer the `RootState`, `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
